module.exports = __webpack_public_path__ + "img/oldmowen.5b8c1c02.png";